import { useMemo } from "react";
import jwtDecode from "jwt-decode";

const useValidateSubscription = (token, requiredProductId) => {
  return useMemo(() => {
    if (!token || !requiredProductId) return false;

    try {
      const decodedToken = jwtDecode(token);
      let subscriptionLicense = decodedToken.subscription_license || [];

      // If it's a string, parse it into an array
      if (typeof subscriptionLicense === "string") {
        subscriptionLicense = [JSON.parse(subscriptionLicense)];
      } else if (Array.isArray(subscriptionLicense)) {
        subscriptionLicense = subscriptionLicense.map((item) =>
          typeof item === "string" ? JSON.parse(item.trim()) : item
        );
      }

      // Normalize for case sensitivity & trim whitespace
      const normalizedRequiredProductId = requiredProductId
        .trim()
        .toLowerCase();

      let hasSub = subscriptionLicense.some((sub) => {
        const normalizedProductId = sub.ProductId.trim().toLowerCase();
        return (
          normalizedProductId === normalizedRequiredProductId &&
          sub.Enabled === true
        );
      });

      return hasSub;
    } catch (error) {
      console.error("Error validating subscription:", error);
      return false;
    }
  }, [token, requiredProductId]);
};

export default useValidateSubscription;
